import { render, staticRenderFns } from "./IconPhoneIncoming.vue?vue&type=template&id=a6fadaf0"
import script from "./IconPhoneIncoming.vue?vue&type=script&lang=js"
export * from "./IconPhoneIncoming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports